import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { Layout } from './components/Layout';
import { agentStudioPath } from './lib/routes';
import { PermissionBoundary } from './components/PermissionBoundary';
import { AGENT_STUDIO_PERMISSIONS as P } from './lib/permissions';

const DashboardPage = lazy(() => import('./pages/DashboardPage').then((module) => ({ default: module.DashboardPage })));
const AgentsListPage = lazy(() => import('./pages/AgentsListPage').then((module) => ({ default: module.AgentsListPage })));
const AgentEditorPage = lazy(() => import('./pages/AgentEditorPage').then((module) => ({ default: module.AgentEditorPage })));
const AgentChatPage = lazy(() => import('./pages/AgentChatPage').then((module) => ({ default: module.AgentChatPage })));
const FlowsListPage = lazy(() => import('./pages/FlowsListPage').then((module) => ({ default: module.FlowsListPage })));
const FlowEditorPage = lazy(() => import('./pages/FlowEditorPage').then((module) => ({ default: module.FlowEditorPage })));
const KnowledgeBasesPage = lazy(() => import('./pages/KnowledgeBasesPage').then((module) => ({ default: module.KnowledgeBasesPage })));
const RunsListPage = lazy(() => import('./pages/RunsListPage').then((module) => ({ default: module.RunsListPage })));
const RunDetailPage = lazy(() => import('./pages/RunDetailPage').then((module) => ({ default: module.RunDetailPage })));
const BudgetPage = lazy(() => import('./pages/BudgetPage').then((module) => ({ default: module.BudgetPage })));
const CostsPage = lazy(() => import('./pages/CostsPage').then((module) => ({ default: module.CostsPage })));
const ActivitiesPage = lazy(() => import('./pages/ActivitiesPage').then((module) => ({ default: module.ActivitiesPage })));
const UsersPage = lazy(() => import('./pages/UsersPage').then((module) => ({ default: module.UsersPage })));

export function AgentStudioApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          element={
            <RequireAuth>
              <PermissionBoundary permission={P.access} fullPage>
                <Layout />
              </PermissionBoundary>
            </RequireAuth>
          }
        >
          <Route index element={<PermissionBoundary permission={P.dashboardView}><DashboardPage /></PermissionBoundary>} />
          <Route path="agents" element={<PermissionBoundary permission={P.agentsView}><AgentsListPage /></PermissionBoundary>} />
          <Route path="agents/:id" element={<PermissionBoundary permission={P.agentsManage}><AgentEditorPage /></PermissionBoundary>} />
          <Route path="agents/:id/chat" element={<PermissionBoundary permission={P.agentsChat}><AgentChatPage /></PermissionBoundary>} />
          <Route path="flows" element={<PermissionBoundary permission={P.flowsView}><FlowsListPage /></PermissionBoundary>} />
          <Route path="flows/:id" element={<PermissionBoundary permission={P.flowsManage}><FlowEditorPage /></PermissionBoundary>} />
          <Route path="templates" element={<Navigate to={agentStudioPath('flows')} replace />} />
          <Route path="knowledge-bases" element={<PermissionBoundary permission={P.knowledgeBasesView}><KnowledgeBasesPage /></PermissionBoundary>} />
          <Route path="budget" element={<PermissionBoundary permission={P.budgetView}><BudgetPage /></PermissionBoundary>} />
          <Route path="users" element={<PermissionBoundary permission={P.usersManage}><UsersPage /></PermissionBoundary>} />
          <Route path="costs" element={<PermissionBoundary permission={P.costsView}><CostsPage /></PermissionBoundary>} />
          <Route path="activities" element={<PermissionBoundary permission={P.activitiesView}><ActivitiesPage /></PermissionBoundary>} />
          <Route path="runs" element={<PermissionBoundary permission={P.runsView}><RunsListPage /></PermissionBoundary>} />
          <Route path="runs/:id" element={<PermissionBoundary permission={P.runsView}><RunDetailPage /></PermissionBoundary>} />
          <Route path="*" element={<Navigate to={agentStudioPath()} replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export { AgentStudioApp as App };
